import { defineComponent as _defineComponent } from 'vue'
import SdsSnackbarQueue from '@ungp/sds-snackbar-queue';
import ParecerReferencialService from '../service/ParecerReferencialService';
import SdsDateField from '@/components/SdsDateField.vue';
import SdsTextField from '@/components/SdsTextField.vue';
import { getFilenameFromHeaders, reloadPage } from '@/utils';
import { reactive } from 'vue';
import { FiltroRelatorioPareceresVencidos } from '../types';
import FileDownload from 'js-file-download';
import { getAxiosError } from '@/plugins/axios';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardRelatorioParecerReferencial',
  setup(__props) {

const getInitialFilter = (): FiltroRelatorioPareceresVencidos => ({
  dtValidadeInicio: null,
  dtValidadeFim: moment().format('DD/MM/yyyy'),
  nuDiasProximoValidade: 30,
  tpImpressao: 'PDF',
});

const state = reactive<FiltroRelatorioPareceresVencidos>(getInitialFilter());

const download = async () => {
  try {
    const { data, headers } =
      await ParecerReferencialService.downloadRelatorioPareceresVencidos(state);

    FileDownload(data, getFilenameFromHeaders(headers));
  } catch (error) {
    SdsSnackbarQueue.error(
      getAxiosError(error, 'Não foi possível realizar o download')
    );
  }
};

return { __sfc: true,getInitialFilter, state, download, SdsDateField, SdsTextField, reloadPage }
}

})